/**
 * Confirms a destructive Regenerate on either proposal layer (document
 * proposals, outline/question proposals).
 *
 * Regenerating replaces the proposal outright — every rename, word count,
 * note, include-toggle, deletion and reorder made during review is gone.
 * Callers only open this when the proposal is dirty; a clean proposal
 * regenerates on the first click with no dialog in the way.
 */

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface RegenerateProposalDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  /** Proceed with the regenerate the user asked for. */
  onConfirm: () => void
}

export function RegenerateProposalDialog({
  open,
  onOpenChange,
  onConfirm,
}: RegenerateProposalDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Regenerate proposal?</AlertDialogTitle>
          <AlertDialogDescription>
            Regenerating discards the edits you’ve made to this proposal.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Regenerate</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
